import { MfNode } from "../node/MfNode";
import { calcExprValue } from "./calcExprValue";

const textValue = (value: unknown): string => {
  if (typeof value === "string") {
    return value;
  }
  if (typeof value === "number" || typeof value === "boolean") {
    return String(value);
  }
  if (value && typeof value === "object") {
    if ("id" in value) {
      const { id } = value as Record<string, unknown>;
      if (typeof id === "string") return id;
    }
  }
  return "";
};

export const evaluateText = (
  srcText: string | null | undefined,
  srcNode: MfNode | undefined,
  root: MfNode,
): string => {
  if (!srcText) return "";
  let dstText = srcText;
  for (;;) {
    const res = /{{([^}]*)}}/.exec(dstText);
    if (!res) break;
    const expr = res[1]!;
    dstText = dstText.replace(
      `{{${expr}}}`,
      textValue(calcExprValue(expr, srcNode ?? root, root)),
    );
  }
  return dstText;
};
